var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"LinkedIn logo"),React.createElement("description",{"key":1},"Find SendGrid on LinkedIn"),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M12.895 11.612h-2.801V7.599c0-1.05-.439-1.768-1.402-1.768-.737 0-1.147.484-1.338.95-.071.168-.06.401-.06.634v4.197H4.518s.036-7.109 0-7.755h2.776v1.217c.164-.532 1.05-1.291 2.467-1.291 1.755 0 3.134 1.115 3.134 3.517v4.312zM1.712 2.887h-.018C.8 2.887.22 2.295.22 1.543.22.777.817.197 1.729.197c.911 0 1.472.579 1.49 1.344 0 .751-.579 1.346-1.507 1.346zM.539 11.612H3.01V3.857H.539v7.755z","fill":"#546B81"}))]);
}

Linkedin.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
